import { optionApi } from '@/api/option/index.ts';
import type { WebapiEndpointBuilder } from '@/api/webapi.ts';

export type CancelOptionBody = {
  rfsId: string;
  tileId: string;
  /**
   * Normally, when we cancel the RFS, we keep the last quote received to display the expired quote.
   * If this is, true, we discard the quote and go back to the initial state (CANCELLED)
   */
  removeQuote?: boolean;
};

export const cancelOptionRfs = (builder: WebapiEndpointBuilder) => {
  return builder.mutation<unknown, CancelOptionBody>({
    query: (body) => {
      return {
        url: '/fxOption/rfs/cancel',
        method: 'POST',
        body: {
          rfsId: body.rfsId,
        },
      };
    },
    onQueryStarted({ rfsId }, { dispatch }): Promise<void> | void {
      dispatch(optionApi.internalActions.removeMutationResult({ fixedCacheKey: rfsId }));
    },
  });
};
